import React, {useState} from 'react';
import {Modal, ModalBody} from 'reactstrap';
import PropTypes from 'prop-types';
import {isEmpty} from 'lodash';
import Close from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import {propertyTrackingReasons, suburbTrackingReasons, propertyClaimTrackingReasons} from '../../../lib/config';
import styles from './TrackReasonsModal.scss';

const TrackReasonsModal = (props) => {

  const {
    showModal,
    handleShowModalChange,
    handleTrackSubmit,
    isPropertyTrackModal,
    trackReason = '',
    forClaiming = false
  } = props;

  const [selectedReason, setSelectedReason] = useState(trackReason);

  const closeModal = () => {
    setSelectedReason('');
    handleShowModalChange();
  };

  const getTrackButton = (type) => {
    return <div className={styles.trackButton} style={{ textAlign: 'center'}}>
      <Button
        variant={'contained'}
        color={'primary'}
        onClick={() => handleTrackSubmit(selectedReason)}
        disabled={isEmpty(selectedReason)}>
        {`Track ${type}`}
      </Button>
    </div>;
  };

  const trackPropertyReasonModal = () => {
    return <Modal isOpen={showModal} toggle={closeModal} className={styles.modalContainer} zIndex={3000}>
      <ModalBody className={styles.modalBody}>
        <h2>Track Property</h2>
        <Close className={styles.closeButton}
          onClick={closeModal}/>
        <p>Track this property to receive monthly updates on the property's estimated value range, nearby properties recently sold or currently listed, as well as local market trends.</p>
        <br/>
        <label className={styles.trackOptionHeader}>What is your relationship to the property?</label>
        <br/>
        <div className={'mt-3'}>
          {Object.keys(forClaiming ? propertyClaimTrackingReasons : propertyTrackingReasons).map(trackReason =>
            <label key={trackReason}
              className={styles.trackOption}
              onClick={() => {
                setSelectedReason(trackReason);
              }}>
              <input type="radio" value={trackReason} name="trackReason"/>
              {propertyTrackingReasons[trackReason]}
            </label>
          )}
        </div>
        {getTrackButton('Property')}
      </ModalBody>
    </Modal>;
  };

  const trackSuburbReasonModal = () => {
    return <Modal isOpen={showModal} toggle={closeModal} className={styles.modalContainer} zIndex={3000}>
      <ModalBody className={styles.modalBody}>
        <h2>Track Suburb</h2>
        <Close className={styles.closeButton}
          onClick={closeModal}/>
        <p>Track this suburb to receive monthly email updates on this suburb's market trends, including
              median values and sold data, plus a snapshot of properties currently listed on the market.</p>
        <br/>
        <label className={styles.trackOptionHeader}>Tell us more about yourself</label>
        <br/>
        <div className={'mt-3'}>
          {Object.keys(suburbTrackingReasons).map(trackReason =>
            <label key={trackReason}
              className={styles.trackOption}
              onClick={() => {
                setSelectedReason(trackReason);
              }}>
              <input type="radio" value={trackReason} name="trackReason"/>
              {suburbTrackingReasons[trackReason]}
            </label>
          )}
        </div>
        {getTrackButton('Suburb')}
      </ModalBody>
    </Modal>;
  };

  return isPropertyTrackModal ? trackPropertyReasonModal() : trackSuburbReasonModal();
};

TrackReasonsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleShowModalChange: PropTypes.func.isRequired,
  handleTrackSubmit: PropTypes.func.isRequired,
  trackReason: PropTypes.string,
  forClaiming: PropTypes.bool
};

export default TrackReasonsModal;
